import locationPinImg from "../../../images/location-dot-solid.png";
import loyaltyUserImg from "../../../images/user-solid.png";
import shoppingCartImg from "../../../images/cart-shopping-solid.png";
import LocationModal from "../location-modal/LocationModal.js";
import PickupDeliveryModal from "../pickup-delivery-modal/PickupDeliveryModal.js";
import MethodChangeModal from "../method-change-modal/MethodChangeModal.js";
import LoyaltyModal from "../loyalty-modal/LoyaltyModal.js";
import * as CommonUtilities from "../../../common/utils/CommonUtils.js";
import BrandLogo from "../../../common/ui/BrandLogo.js";

export default function MenuNavigation(props) { 
    // let estimateTimeDelivery = null;
    // let slicedDateToFormat = null; 
    // let estimateDeliveryDisplay = null;
    // if (props.pickupOrDelivery.DeliveryStatus.EstimateDeliveryTime !== null) {
    //     estimateTimeDelivery = props.pickupOrDelivery.DeliveryStatus.EstimateDeliveryTime; 
    //     slicedDateToFormat = estimateTimeDelivery.slice(0, 19);
    //     estimateDeliveryDisplay = moment(slicedDateToFormat, 'YYYY-MM-DDTHH:mm:ss').format('DD/MM/YYYY h:mmA');
    // }
    
    // Location Button
    let locationButton;
    if (props.urlConfig.Type === '' || props.urlConfig.Type === null || props.urlConfig.Type === 'null' || props.urlConfig.Type === 'web') { // Web Ordering
        if (props.pickupOrDelivery.SwitchMenuNav.SwitchPickupDeliveryValue === 'delivery') {
            // Delivery - static location
            locationButton = <>
                                <span className="my-auto d-none d-sm-inline text-nowrap">The selected store is </span>
                                <div title="Location" className="h6 text-bg-light py-2 px-3 my-auto ms-0 ms-sm-2 me-2 rounded-2 border text-truncate flex-grow-1 flex-sm-grow-0" style={{cursor: "default", minWidth: 0}}>{props.currentLocation.LocationName}</div>
                            </>
        } else {
            // Pickup - ability to change locations
            locationButton = <>
                                <span className="d-none d-sm-inline text-nowrap">The selected store is </span>
                                <button type="button" className="btn btn-light rounded-pill text-truncate flex-grow-1 flex-sm-grow-0 ms-0 ms-sm-2 me-2" onClick={props.handleShowLocModal} style={{height: "38px", minWidth: 0}}>
                                    <img src={locationPinImg} alt="Location" title="Location" style={{width: "14px"}}></img>
                                    &ensp;{props.currentLocation.LocationName}
                                </button>
                            </>
        }
    } else {
        if (props.urlConfig.Type == 'k7s5k') { // Kiosk
            locationButton = <div title="Kiosk" className="h6 text-bg-light py-2 px-3 my-auto mx-2 rounded-2 border text-truncate" style={{cursor: "default"}}>Kiosk</div>
        } else if (props.urlConfig.Type == 'q8r6e') { // QR Code
            locationButton = <div title="QR Code" className="h6 text-bg-light py-2 px-3 my-auto mx-2 rounded-2 border text-truncate" style={{cursor: "default"}}>QR Code</div>
        } else if (props.urlConfig.Type == 't9b6f') { // Table Number
            locationButton = <div title={`Table ${props.urlConfig.TableNumber}`} className="h6 text-bg-light py-2 px-3 my-auto mx-2 rounded-2 border text-truncate" style={{cursor: "default"}}>Table {props.urlConfig.TableNumber}</div>
        } else {
            locationButton = <>
                                <span className="my-auto d-none d-sm-inline text-nowrap">The selected store is </span>
                                <div title="Location" className="h6 text-bg-light py-2 px-3 my-auto ms-0 ms-sm-2 me-2 rounded-2 border text-truncate flex-grow-1 flex-sm-grow-0" style={{cursor: "default", minWidth: 0}}>{props.currentLocation.LocationName}</div>
                            </>
        }
    }

    // Loyalty Button
    let loyaltyButton = <button type="button" className="btn btn-light rounded-pill text-truncate me-2" onClick={props.handleClickOpenLoyaltyModal} style={{minWidth: "100px", height: "38px"}}>
                            <img src={loyaltyUserImg} alt="Loyalty User" style={{width: "14px"}}></img>
                            &ensp;{props.loyaltyMember.MenuNav.LoyaltyMemberButtonValue}
                        </button>

    // Pickup / Delivery Switch
    let pickupDeliverySwitch;
    if (props.urlConfig.Type == 'web' || props.urlConfig.Type == 'null' || props.urlConfig.Type == null || props.urlConfig.Type == '') {

        pickupDeliverySwitch = <div className="btn-group" role="group" aria-label="Button group for pick up or delivery selection">
                                <input type="radio" className="btn-check" name="pickupdelivery" id="btnRadioPickup" data-value="pickup" onChange={props.handlePickupDeliverySwitch} checked={props.pickupOrDelivery.SwitchMenuNav.SwitchPickupDeliveryValue === 'pickup'} />
                                <label className="btn btn-outline-primary" htmlFor="btnRadioPickup">Pick Up</label>
                                <input type="radio" className="btn-check" name="pickupdelivery" id="btnRadioDelivery" data-value="delivery" onChange={props.handlePickupDeliverySwitch} checked={props.pickupOrDelivery.SwitchMenuNav.SwitchPickupDeliveryValue === 'delivery'} />
                                <label className="btn btn-outline-primary" htmlFor="btnRadioDelivery">Delivery</label>
                            </div>
    } else {
        pickupDeliverySwitch = <></>
    }
     
    return (
        <>
            <header className="shadow-sm bg-white sticky-top">
                <div className="container-lg">
                    <div className="d-flex justify-content-between row">
                        <div className="col-12 col-sm py-md-2 py-2 text-center text-sm-start my-auto">
                            <div className="d-flex flex-row flex-wrap align-items-center gap-3 justify-content-center justify-content-sm-start">
                                <div className="ms-sm-1 ms-0" style={{paddingLeft: "1px"}}>
                                    <BrandLogo />
                                </div>
                            </div>
                            {
                                props.pickupOrDelivery.PickupDeliveryModal.DeliveryAvailabilityHasBeenChecked && 
                                props.pickupOrDelivery.Config.EnableDoorDashWhiteLabelDelivery && 
                                pickupDeliverySwitch // Show Switch
                            }
                        </div>
                        {props.pickupOrDelivery.SwitchMenuNav.SwitchPickupDeliveryValue === 'delivery' && props.pickupOrDelivery.DeliveryStatus.EstimateDeliveryTime !== null &&
                            <div className="col-12 col-sm py-2">Delivery Time Estimate: {props.pickupOrDelivery.DeliveryStatus.EstimateDeliveryTime}</div>
                            //<div className="col py-2">Delivery Time Estimate: {estimateDeliveryDisplay}</div>
                        } 
                        <div className="col-12 col-sm-auto flex-sm-shrink-1 d-flex justify-content-end align-items-center pt-0 pb-2 py-sm-2" style={{minWidth: 0}}>
                            {locationButton}
                            {CommonUtilities.StaticFields.EnableBrandLoyalty ? loyaltyButton : <></>}
                            <button type="button" className="btn btn-dark rounded-pill px-1" style={{height: "38px", minWidth: "64px"}} onClick={props.handleViewCart} disabled={props.amountInCart < 1}>
                                <img src={shoppingCartImg} alt="Cart" title="Cart" style={{width: "18px"}}></img>
                                &ensp;{props.amountInCart}
                            </button>
                        </div>
                    </div>                    
                </div>
            </header>
            <LocationModal 
                locationList={props.locationList} 
                getGeoLocation={props.getGeoLocation} 
                locationLoading={props.locationLoading} 
                locationSearchInputRef={props.locationSearchInputRef}
                handleFocusSearchLocation={props.handleFocusSearchLocation}
                handleSearchLocation={props.handleSearchLocation}
                handleClearSearchLocation={props.handleClearSearchLocation}
                handleToggleOpenLocation={props.handleToggleOpenLocation}
                handleSelectLocation={props.handleSelectLocation}
                currentLocation={props.currentLocation}
                handleShowLocModal={props.handleShowLocModal}
                show={props.showLocModal}
                handleCloseLocModal={props.handleCloseLocModal}
                locationError={props.locationError}
                menuError={props.menuError}
                // Pickup - Shown in Location
                handleBackPickupLocationsToMethodClick={props.handleBackPickupLocationsToMethodClick}
                // --- Pickup / Delivery ---
                pickupOrDelivery={props.pickupOrDelivery}
            />
            <PickupDeliveryModal
                pickupOrDelivery={props.pickupOrDelivery}
                handleSelectMethodPickupDeliveryModal={props.handleSelectMethodPickupDeliveryModal}
                handleChangeAddressFields={props.handleChangeAddressFields}
                handleSubmitAddressFields={props.handleSubmitAddressFields}
                handleBackAddressToMethodClick={props.handleBackAddressToMethodClick}
            />
            <LoyaltyModal
                // General
                loyaltyMember={props.loyaltyMember}
                handleClickCloseLoyaltyModal={props.handleClickCloseLoyaltyModal}
                currentLocation={props.currentLocation}
                // Login Page
                handleClickLoginLoyaltyMobile={props.handleClickLoginLoyaltyMobile}
                // Mobile Page
                handleChangeMobileFields={props.handleChangeMobileFields}
                handleNextValidateMobile={props.handleNextValidateMobile}
                // OTP Page
                handleBackOtpPage={props.handleBackOtpPage}
                handleChangeOtpFields={props.handleChangeOtpFields}
                handleResendOtpToMobile={props.handleResendOtpToMobile}
                handleNextValidateOtp={props.handleNextValidateOtp}
                // Voucher List Page
                handleLoyaltyLogout={props.handleLoyaltyLogout}
                handleSelectVoucher={props.handleSelectVoucher}
                // Item Voucher Parent Page
                handleBackItemVoucherParent={props.handleBackItemVoucherParent}
                handleSelectGroupItemVoucherParent={props.handleSelectGroupItemVoucherParent}
                handleAddVoucherToCartItemVoucherParent={props.handleAddVoucherToCartItemVoucherParent}
                // Item Voucher Product List Page
                handleBackItemVoucherProductList={props.handleBackItemVoucherProductList}
                handleSelectProductItemVoucherProductList={props.handleSelectProductItemVoucherProductList}
                // Item Voucher Child Page
                handleBackItemVoucherChild={props.handleBackItemVoucherChild}
                handleModChangeItemVoucherChild={props.handleModChangeItemVoucherChild}
                handleAddToVoucherItemVoucherChild={props.handleAddToVoucherItemVoucherChild}
            />
            <MethodChangeModal 
                pickupOrDelivery={props.pickupOrDelivery}
                handleCloseMethodChangeModal={props.handleCloseMethodChangeModal}
                handleConfirmMethodChange={props.handleConfirmMethodChange}
            />
        </>
    );
}